export default "__VITE_ASSET__XfidWCvC__"